<template>
  <!-- 新闻资讯 -->
  <div class="information">
    <el-form :inline="true" :model="set" class="demo-form-inline bginput" label-width="6rem">
      <el-form-item label="政策文件">
        <el-select v-model="set.policy" placeholder="请选择">
          <el-option label="手动录入" :value="0"></el-option>
          <el-option label="后台获取" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="行业新闻">
        <el-select v-model="set.industry" placeholder="请选择">
          <el-option label="手动录入" :value="0"></el-option>
          <el-option label="后台获取" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业新闻">
        <el-select v-model="set.enterprise" placeholder="请选择">
          <el-option label="手动录入" :value="0"></el-option>
          <el-option label="后台获取" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small">保存设置</el-button>
      </el-form-item>
    </el-form>

    <el-table class="eltabletl" border :data="tableData" style="width: 100%">
      <el-table-column prop="inum" label="编号" width="400"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="type" label="类别" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.type==1">政策文件</span>
          <span v-if="scope.row.type==2">行业新闻</span>
          <span v-if="scope.row.type==3">企业新闻</span>

        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="排序" width="200"></el-table-column>

      <el-table-column prop="createTime" label="发布时间" width="400"></el-table-column>
      <el-table-column fixed="right" label="操作" width="300">
        <template slot="header">
            操作
            <i @click="addFrom()" style="font-size: 0.9rem;font-weight: 600;cursor:pointer;position: relative;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
         
        </template>

        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click.stop="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click.stop="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--详情-->
    <el-dialog v-dialogDrag title="新闻资讯详情" :visible.sync="addformData" width="50%" :before-close="handleClose">
      <div style="min-height: 450px">
        <el-form ref="formData" :model="formData" label-width="6rem">
          <el-col :span="6">
            <el-form-item label="新闻名称">
              <el-input required maxlength="200" v-model="formData.title" placeholder="请输入新闻名称" :disabled="flag == 'look'"></el-input>
            </el-form-item>
            <el-form-item label="新闻排序">
              <el-input maxlength="8" v-model.number="formData.orderNum" placeholder="0~100" :disabled="flag == 'look'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="新闻类别">
              <el-select v-model="formData.type" placeholder="请选择">
                <el-option label="政策文件" :value="1"></el-option>
                <el-option label="行业新闻" :value="2"></el-option>
                <el-option label="企业新闻" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发表日期">
              <el-date-picker :disabled="flag == 'look'" v-model="formData.createTime" type="date" placeholder="选择日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="封面图片">
              <el-upload :disabled="flag == 'look'" class="avatar-uploader" :http-request="uploadfile" action="" :show-file-list="false">
                <img class="avatar" v-if="formData.url" :src="formData.url">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="新闻简介">
              <el-input maxlength="300" v-model="formData.remark" placeholder="请在此输入新闻简介" type="textarea" :rows="2" :disabled="flag == 'look'"></el-input>
            </el-form-item>
          </el-col>

          <el-col v-show="flag == 'look'" :span="24">
            <!-- 查看 -->
            <el-form-item label="新闻内容">
              <div style="max-height: 380px;" v-html="formData.content"></div>
            </el-form-item>
          </el-col>
          <el-col v-show="flag != 'look'" :span="24">
            <!-- 编辑 -->
            <el-form-item label="新闻内容">
              <wangeditor ref="wangeditor" />
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addformData = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wangeditor from '@/components/wangeditor'
import api from '@/apis/recommend/information'
import upapi from '@/apis/upload'
export default {
  components: {
    wangeditor,
  },
  data() {
    return {
      addformData: false,
      flag: 'look',
      set: {
        policy: 0,
        industry: 0,
        enterprise: 0,
      },
      formData: {},
      tableData: [],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {

            this.tableData = res.data.list
            
          } else {
            this.$message.error(res.message)
          }
        })
    },
    addFrom() {
      this.flag = 'add'
      this.formData = {
        createTime: '',
        title: '',
        orderNum: 0,
        type: 3, //类型 1：政策文件 2:行业新闻 3:企业新闻
        content: '',
        url: '',
      }
      this.addformData = true
      //清空文本编辑器
      this.$nextTick(() => {
        this.$refs.wangeditor.clear()
      })
    },
    edit(row) {
      this.flag = 'edit'
      this.formData = row
      this.addformData = true
      this.$nextTick(() => {
        this.$refs.wangeditor.sethtml(row.content)
      })
    },
    handleClose(done) {
      if (this.flag == 'look') {
        return done()
      }
      this.$confirm('确认关闭？ 数据不会被保存！')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    save() {
      this.formData.content = this.$refs.wangeditor.gethtml()
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.addformData = false
        } else {
          this.$message.error(res.message)
        }
        this.getlist()
      })
    },
    del(item) {
      this.$confirm(`确定删除数据？`).then(() => {
        api.del([item.id]).then((res) => {
          if (res.code === 10000) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
          this.getlist()
        })
      })
    },
    //上传图片
    uploadfile(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.formData.url = res.data
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.information { padding-top:7px;
  .avatar,
  .avatar-uploader-icon {
    width: 9rem !important;
    height: 6rem !important; border:#3570ff solid 1px; border-radius: 4px; font-size: 2rem;
    line-height: 6rem !important;
  }
}
</style>